import { Button } from '../../design-system/primitives/index.js'

/**
 * Shown when the pantry is empty and the quick-add starter was skipped for the session.
 * @param {{ onAddItems: () => void }} props
 */
export default function PantryUnlockMealsBanner({ onAddItems }) {
  return (
    <section className="pantry-unlock-meals-banner" aria-labelledby="pantry-unlock-meals-heading">
      <div className="pantry-unlock-meals-banner__content">
        <h2 id="pantry-unlock-meals-heading" className="pantry-unlock-meals-banner__title">
          Stock your pantry
        </h2>
        <p className="pantry-unlock-meals-banner__body">
          Tell us what you keep on hand and Captain Cook can tailor recipes and plans to your kitchen.
        </p>
      </div>
      <Button
        type="button"
        variant="primary"
        className="pantry-unlock-meals-banner__cta"
        onClick={onAddItems}
      >
        Add items
      </Button>
    </section>
  )
}
